module.exports = __webpack_public_path__ + "static/VietNam-a95191d0df203d324eb97b9c7044b254.svg";